const TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "post-load", label: "Post Load" },
  { key: "loads", label: "Load List" },
  { key: "find-drivers", label: "Find Drivers" },
  { key: "my-drivers", label: "My Drivers" },
  { key: "groups", label: "Driver Groups" },
  { key: "service-logs", label: "Service Logs" },
  { key: "billing", label: "Billing" },
  { key: "team", label: "Team" },
];

export const BrokerPortalNav = ({ active, onChange }) => (
  <nav data-testid="broker-portal-nav" className="flex flex-wrap gap-2 border-b border-rr-line pb-4 mb-8">
    {TABS.map((t) => (
      <button
        key={t.key}
        onClick={() => onChange(t.key)}
        data-testid={`broker-portal-nav-${t.key}`}
        className={`text-sm font-bold px-4 py-2 rounded-full transition-colors ${
          active === t.key ? "bg-rr-navy text-white" : "bg-white border border-rr-line text-rr-muted hover:border-rr-orange"
        }`}
      >
        {t.label}
      </button>
    ))}
  </nav>
);
